export default {
  features: {
    index: {
      seo: {
        title: 'Toutes les fonctionnalités',
        description:
          'Outils IA pour la gestion de livraison : suivi de marque, optimisation d\'itinéraires, agents IA, preuve de livraison, allocation automatique, analyses et plus.',
      },
      badge: 'Fonctionnalités de la plateforme',
      title: 'Toutes les fonctionnalités',
      subtitle:
        'Outils IA pour la livraison, le routage, la preuve de livraison et les opérations de flotte. Explorez chaque fonctionnalité ci-dessous.',
      stats: {
        features: 'Fonctionnalités',
        aiPowered: 'Propulsé par l\'IA',
        dispatchRouting: 'Dispatch et routage',
        uptime: 'Disponibilité de la plateforme',
      },
      learnMore: 'En savoir plus',
      cta: {
        title: 'Prêt à essayer Geofleet ?',
        subtitle: 'Commencez dès maintenant ou réservez une démo pour voir ces fonctionnalités en action.',
      },
    },
  },
};
